export default "__VITE_ASSET__zs34oPSa__"